<template>
  <div class="rc-group-design">
    <fieldset>
      <legend>{{initComponent.name}}</legend>
      <draggable
        class="layout-group"
        :class="'a_' + initComponent.id"
        ref="draggable"
        v-model="initComponent.children"
        :options="{group:'rc-group'}">
        <transition-group name="list-component">
          <div
            class="list-component-item"
            v-for="component in initComponent.children"
            :class="[{'list-component-item-select': selectId===component.id}, component.componentType]"
            :key="component.id"
            @click.stop="openAttrForChildren(component)">
            <i class="delete-component" @click.stop="removeComponent(component)"></i>
            <component
              ref="childrenComponent"
              :is="component.componentType"
              :initComponent="component"
              :selectId="selectId"
              :highlightId="highlightId"
              :nodeIsCountersign="nodeIsCountersign"
              :parentComponent="parentComponent">
            </component>
          </div>
        </transition-group>
      </draggable>
    </fieldset>
  </div>
</template>

<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
import interact from 'interactjs'
import {offsetXYFromParentOf} from '../../dragUtil'
import {getProperties} from '@/store/form/componentDefaults.js'
import RcLayout from '../layout/rc-layout.vue'

const acceptComponent = ['rc-layout']

export default {
  name: 'rc-group',
  inject: ['formService', 'componentEventBus'],
  props: [ 'initComponent', 'selectId', 'nodeIsCountersign', 'parentComponent', 'highlightId' ],
  components: {
    Draggable,
    RcLayout
  },
  data () {
    return {
      page: {
        dragger: {
          dragging: false,
          mouseOffset: {}
        }
      }
    }
  },
  mounted () {
    let _this = this
    interact(`.a_${_this.initComponent.id}`).dropzone({
      // only accept elements matching this CSS selector
      accept: '.component-template',
      ondragenter: function (event) {
        // 进入当前容器区域时
      },
      ondragleave: function (event) {
        // 离开当前容器区域
      },
      ondrop: _.debounce((event) => {
        let componentType = event.dragEvent.currentTarget.getAttribute('component-type')
        let componentName = event.dragEvent.currentTarget.getAttribute('component-name')
        if (acceptComponent.includes(componentType)) {
          let position = offsetXYFromParentOf(event)
          let componentHeights = []
          let components = _this.$refs.draggable.$el.children[0].children

          for (let i = 0, length = components.length; i < length; i++) {
            componentHeights.push(components[i].offsetHeight + 10)
          }

          let index = componentHeights.length ? componentHeights.length + 1 : 0
          for (let j = 0, length = componentHeights.length; j < length; j++) {
            let top = componentHeights.slice(0, j).reduce((x, y) => x + y, 0)
            let bottom = top + componentHeights[j]
            if (top < position.y && position.y < bottom) {
              if ((position.y - top) > (componentHeights[j] / 2)) {
                // 放下面
                index = j + 1
              } else {
                // 放上面
                index = j
              }
              break
            }
          }
          _this.addComponent({componentType, componentName, index})
        }
      })
    })
  },
  methods: {
    async addComponent (params) {
      let componentType = params.componentType
      let component = getProperties(componentType)

      if (componentType === 'rc-layout') {
        component.defaults.name = params.componentName
      }
      let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      component.defaults.pinyinName = pinyin.pinyinName
      component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
      let cm = this.formService.createComponent(component, this.initComponent, params.index)
      this.$nextTick(() => {
        let table = this.formService.schema.getTable(cm.archive.tableId)
        // 表格不需要改列的值
        if (cm.componentType === 'rc-table') {
          table.pinyinName = pinyin.pinyinName
          table.pinyinFirstChar = pinyin.pinyinFirstChar
        } else {
          if (table && table.columns) {
            let c = table.columns.find(c => c.id === cm.archive.columnId)
            c.pinyinName = pinyin.pinyinName
            c.pinyinFirstChar = pinyin.pinyinFirstChar
          }
        }
      })
    },
    removeComponent (component) {
      this.$confirm('', '你确定要删除吗,全部的子控件也会删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      })
        .then(res => {
          let components = this.initComponent.children.find(m => m.id === component.id)
          this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentList', id: component.id})
          this.formService.removeComponent(components)
        })
    },
    openAttrForChildren (component) {
      if (!['rc-draggable', 'rc-layout'].some(n => n === component.componentType)) {
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentAttr', id: component.id})
        this.selectId = component.id
      }
    }
  },
  watch: {
    'initComponent.children' (val) {
      this.initComponent.properties.childrenSort = val.map(n => n.id)
    }
  }
}
</script>

<style lang="scss">
  .rc-group-design {
    .layout-group {
      > span {
        display: block;
        padding-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/group/rc-group.vue